import { useRef, useState } from 'react';
import styles from './MarketPlaceFilter.module.css';
import { IMarketPlaceFilters, ISubCategoryData } from '@/interfaces';
import { useGlobalContext } from '@/lib/context';
import sortItems from '../../../../data/marketPlaceSortItems.json';
import { pushRoute } from '@/lib/helpers/common';
import { NavLink } from '@/components/ui';
type props = {
    filters: IMarketPlaceFilters[]
    checkedAtrributes: [{ AttributeNameSlug: string, AttributeValueSlug: string }],
    handleAttributes: Function
    isMobileFilterActive: Boolean
    setMobileFilterActive: Function
    fetchProducts: Function
    handleSort: Function
    minPrice: number
    maxPrice: number
    setMinPrice: Function
    setMaxPrice: Function
    data: ISubCategoryData
}
export function MarketPlaceFilter({ filters, checkedAtrributes, isMobileFilterActive, setMobileFilterActive, handleSort, minPrice, maxPrice, setMinPrice, setMaxPrice, data }: props) {
    const [sortMenu, setSortMenu] = useState(false)
    const { props: { isMobileView ,isAppView} } = useGlobalContext();
    const [active, setActive] = useState<any>(9999);
    const sliderTrackRef = useRef<HTMLDivElement>(null);
    const handleClick = (e: Event, idx: Number) => {
        if (idx === active) {
            setActive(-1)
        } else setActive(idx)
    };

    const handleMinChange = (e: any) => {
        const value = Math.min(Math.max(data.minPrice, Number(e.target.value)), maxPrice - 1);
        setMinPrice(value);
    };

    const handleMaxChange = (e: any) => {
        const value = Math.min(Math.max(data.minPrice + 1, Number(e.target.value)), data.maxPrice);
        setMaxPrice(value);
    };
    const handlePriceChange = () => {
        let url = `${process.env.SITE_URL}/online-store/${data.serviceSlug}/${data.categorySlug}/search?min-price=${minPrice}&max-price=${maxPrice}`;
        if (checkedAtrributes && Object.keys(checkedAtrributes).length > 0) {
            Object.entries(checkedAtrributes).forEach(([AttributeNameSlug, AttributeValueSlug]) => {
                if (AttributeNameSlug && AttributeValueSlug) {
                    url += `&${AttributeValueSlug.AttributeNameSlug}=${AttributeValueSlug.AttributeValueSlug}`;
                }
            });
        }
        pushRoute(url);
    };
    const handleTrackClick = (e: React.MouseEvent<HTMLDivElement> | any) => {
        if (!sliderTrackRef.current) return;
        const rect = sliderTrackRef.current.getBoundingClientRect();
        const clickPosition = e.clientX - rect.left;
        const trackWidth = rect.width;
        const clickPercentage = clickPosition / trackWidth;

        const priceRange = data.maxPrice - data.minPrice;
        const clickedPrice = Math.round(data.minPrice + (priceRange * clickPercentage));

        // Determine whether to update min or max price based on which is closer
        const distanceToMin = Math.abs(clickedPrice - minPrice);
        const distanceToMax = Math.abs(clickedPrice - maxPrice);

        if (distanceToMin <= distanceToMax) {
            setMinPrice(Math.min(clickedPrice, maxPrice - 1));
        } else {
            setMaxPrice(Math.max(clickedPrice, minPrice + 1));
        }
        handlePriceChange();
    };
    return (
        <>
            <div className={`${styles.productFilterBox} ${isMobileFilterActive && styles.active}`}>
                <div className={styles.productFilterBy}>
                    <em onClick={() => {
                        setMobileFilterActive(false),
                            document.body.classList.remove('overflow-hidden')
                    }}></em>
                    <label className="font14 text000 f600 ">Filters</label>
                </div>
                <div className={styles.productFilterType}>
                    {isMobileView && <>
                        <ul className={styles.mobileTabFilter}>
                            {/* price filter  */}
                            <li className={active === 9999 ? styles.active : ''} key={9999} onClick={(e: any) => handleClick(e, 9999)}>Price</li>
                            {/* price filter  */}
                            {
                                filters && filters.map((f, idx) =>
                                    <li className={active === idx ? styles.active : ''} key={idx} onClick={(e: any) => handleClick(e, idx)}>{f.attributeName}</li>
                                )
                            }
                        </ul>

                    </>
                    }
                    {/* price filter  */}
                    <div className={`${styles.filterType} ${active === 9999 && styles.active}`} key={9999}>
                        <div className={styles.filterHead} onClick={(e: any) => handleClick(e, 9999)}>
                            <label className="font12 text000 f600">Price</label>
                            <span className={styles.menuHead}></span>
                        </div>
                        <div className={`${styles.priceFilter} ${styles.filterBdy}`}>
                            <div className={styles.rangeSlider}>
                                <div className={styles.sliderTrack} ref={sliderTrackRef} onClick={(e) => handleTrackClick(e)}>
                                </div>
                                <div
                                    className={styles.sliderRange}
                                    onClick={(e) => handleTrackClick(e)}
                                    onMouseUp={(e) => handleTrackClick(e)}
                                    onTouchEnd={(e) => handleTrackClick(e)}
                                    style={{
                                        left: `${((minPrice - data.minPrice) / (data.maxPrice - data.minPrice)) * 100}%`,
                                        right: `${100 - ((maxPrice - data.minPrice) / (data.maxPrice - data.minPrice)) * 100}%`,
                                    }}
                                ></div>
                                <input
                                    type="range"
                                    min={data.minPrice}
                                    max={data.maxPrice}
                                    value={minPrice}
                                    onChange={handleMinChange}
                                    onMouseUp={() => handlePriceChange()}
                                    onTouchEnd={() => handlePriceChange()}
                                    className={styles.sliderMin}
                                />
                                <input
                                    type="range"
                                    min={data.minPrice}
                                    max={data.maxPrice}
                                    value={maxPrice}
                                    onChange={handleMaxChange}
                                    onMouseUp={() => handlePriceChange()}
                                    onTouchEnd={() => handlePriceChange()}
                                    className={styles.sliderMax}
                                />
                            </div>
                            <span className={styles.priceRange}>₹{minPrice} - ₹{maxPrice}</span>
                        </div>
                    </div>
                    {/* price filter  */}
                    {
                        filters && filters.map((f, idx) =>
                            <div className={`${styles.filterType} ${active === idx && styles.active}`} key={idx}>
                                <div className={styles.filterHead} onClick={(e: any) => handleClick(e, idx)}>
                                    <label className="font12 text000 f600">{f.attributeName}</label>
                                    <span className={styles.menuHead}></span>
                                </div>
                                <ul className={styles.filterBdy}>
                                    {f && f.attributeValues && f.attributeValues.map((m, idx2) =>
                                        <li key={idx2} onClick={(e) => pushRoute(m.url)}>
                                            <input
                                                type="checkbox"
                                                readOnly
                                                checked={m.isSelectedAttributeValue == 1}
                                            />
                                            <label className="font12 text222">
                                                {   
                                                    (m.url.includes('/search') || m.url.includes(`/online-store/${data.serviceSlug}/${data.categorySlug}`)) ?
                                                        m.attributeValue :
                                                        <NavLink key={idx2} href={m.url}>
                                                            {m.attributeValue}
                                                        </NavLink>
                                                }
                                                <span className="text666">({m.productCount})</span>
                                            </label>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        )}
                </div>
                <div className={styles.mobileFilterBtn}>
                    <button type="button" className={styles.resetBtn} onClick={() => pushRoute(`/online-store/${data.serviceSlug}/${data.categorySlug}`)}>reset</button>
                    {/* <button type="button" className={`primaryBtn ${styles.applytBtn}`} onClick={() => { fetchProducts(1, checkedAtrributes), setMobileFilterActive(false) }}>apply</button> */}
                </div>
            </div>
            <ul className={styles.sortNfilterBox}>
                <li>
                    <label onClick={() => setSortMenu(!sortMenu)}>
                        <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.226 8.784H.774a.783.783 0 0 0-.547.222.75.75 0 0 0 0 1.072.783.783 0 0 0 .547.222h14.452c.205 0 .402-.08.547-.222a.75.75 0 0 0 0-1.072.782.782 0 0 0-.547-.222zM.774 6.258h8.258c.206 0 .403-.08.548-.222a.75.75 0 0 0 0-1.072.782.782 0 0 0-.548-.222H.774a.783.783 0 0 0-.547.222.75.75 0 0 0 0 1.072.783.783 0 0 0 .547.222zM.774 2.216h8.258c.206 0 .403-.08.548-.222a.75.75 0 0 0 0-1.072A.783.783 0 0 0 9.032.7H.774a.783.783 0 0 0-.547.222.75.75 0 0 0 0 1.072.783.783 0 0 0 .547.222zM12.614 7.046a.806.806 0 0 0 .547.223.805.805 0 0 0 .547-.222l1.858-1.82a.749.749 0 0 0-.019-1.052.783.783 0 0 0-1.075-.019l-.537.526V1.457a.75.75 0 0 0-.226-.536.783.783 0 0 0-1.095 0 .75.75 0 0 0-.227.536V4.68l-.537-.525a.775.775 0 0 0-.553-.241.789.789 0 0 0-.56.222.755.755 0 0 0-.227.55.742.742 0 0 0 .246.54l1.858 1.82z" fill="#EB5976" />
                        </svg>
                        <span className='textpink font14'>Sort</span>
                    </label>
                    <div className={sortMenu ? styles.subMenuSection + " " + styles.active : styles.subMenuSection}>
                        <div className={styles.subMenuWithClose} onClick={() => setSortMenu(!sortMenu)} style={isAppView ? { bottom: "-57px" } : {}}>
                            <div className={styles.subMenuCloseBtn}><span className={styles.closeBtn}></span></div>
                            <ul>
                                {
                                    sortItems.map((f, idx) =>
                                        <li key={idx} value={f.key} className={styles.subMenuDtls} onClick={() => handleSort(f.key)}>{f.value}</li>
                                    )
                                }
                            </ul>
                        </div>
                    </div>
                </li>
                <li>
                    <label onClick={() => setMobileFilterActive(true)}>
                        <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M2.333 5.3c1.289 0 2.334-1.075 2.334-2.4S3.622.5 2.333.5C1.045.5 0 1.575 0 2.9s1.045 2.4 2.333 2.4zm0-1.6a.79.79 0 0 0 .778-.8.79.79 0 0 0-.778-.8.79.79 0 0 0-.777.8c0 .442.348.8.777.8zM9.466 8.3c.32.932 1.185 1.6 2.2 1.6C12.957 9.9 14 8.826 14 7.5c0-1.325-1.045-2.4-2.333-2.4-1.016 0-1.88.668-2.2 1.6H.776A.79.79 0 0 0 0 7.5c0 .442.348.8.778.8h8.688zm2.2 0a.79.79 0 0 0 .778-.8.79.79 0 0 0-.777-.8.79.79 0 0 0-.778.8c0 .442.348.8.778.8zM6.222 14.5c-1.016 0-1.88-.668-2.2-1.6H.778A.79.79 0 0 1 0 12.1c0-.442.348-.8.778-.8h3.244c.32-.932 1.184-1.6 2.2-1.6 1.289 0 2.334 1.074 2.334 2.4 0 1.325-1.045 2.4-2.334 2.4zM7 12.1a.79.79 0 0 1-.778.8.79.79 0 0 1-.778-.8c0-.442.349-.8.778-.8a.79.79 0 0 1 .778.8z" fill="#EB5976" />
                            <path d="M6.222 2.9c0-.442.348-.8.778-.8h6.222c.43 0 .778.358.778.8 0 .442-.348.8-.778.8H7a.79.79 0 0 1-.778-.8zM10.889 11.3a.79.79 0 0 0-.778.8c0 .442.348.8.778.8h2.333a.79.79 0 0 0 .778-.8.79.79 0 0 0-.778-.8H10.89z" fill="#EB5976" />
                        </svg>
                        <span className='textpink font14'>Filter</span>
                    </label>
                </li>
            </ul>
        </>
    )
}